/* CACHE — general UI: mobile nav, sticky ATC, product card variant tabs, PDP variants. */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) {
      document.body.classList.toggle('nav-open');
      var open = document.body.classList.contains('nav-open');
      e.target.closest('[data-nav-toggle]').setAttribute('aria-expanded', open);
    }
  });

  /* ---- Sticky ATC on PDP: show after main buy section scrolls past ---- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---- Product-card variant tabs (5-pack / 10-pack) ---- */
  document.querySelectorAll('[data-variant-tabs]').forEach(function (group) {
    var card = group.closest('[data-pcard]');
    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var id = btn.getAttribute('data-variant-id');
        var price = btn.getAttribute('data-variant-price');
        var compare = btn.getAttribute('data-variant-compare');
        if (card) {
          var input = card.querySelector('[name="id"]');
          if (input) input.value = id;
          var priceEl = card.querySelector('[data-pcard-price]');
          if (priceEl) {
            priceEl.innerHTML = (compare ? '<del>' + compare + '</del> ' : '') + price;
          }
        }
      });
    });
  });

  /* ---- PDP variant selector ---- */
  document.querySelectorAll('[data-pdp-variants]').forEach(function (sel) {
    var root = sel.closest('[data-product-root]');
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var input = root.querySelector('[name="id"]');
      if (input) input.value = opt.value;
      var priceEl = root.querySelector('[data-pdp-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && opt.dataset.price) stickyPrice.textContent = opt.dataset.price;
      var stickyInput = document.querySelector('[data-sticky-atc] [name="id"]');
      if (stickyInput) stickyInput.value = opt.value;
    });
  });

  /* ---- Founding Batch capture: AJAX to Shopify customer form is native;
         we only enhance the success message when using the customer form. ---- */
})();
